import { OTPInput as Lib } from "input-otp";

/**
 * Input de código de 6 dígitos (email OTP ou TOTP).
 * Suporta paste ("123 456" ou "123456") e autofill mobile via one-time-code.
 */
export default function OTPInput({ value, onChange, onComplete, disabled, error }) {
  return (
    <Lib
      maxLength={6}
      value={value}
      onChange={onChange}
      onComplete={onComplete}
      disabled={disabled}
      autoFocus
      containerClassName="flex gap-2 justify-center"
      render={({ slots }) => (
        <>
          {slots.map((s, i) => (
            <div
              key={i}
              className={`w-12 h-14 flex items-center justify-center text-2xl font-mono
                border ${error ? "border-destructive" : "border-white/15"}
                bg-white/5 ${s.isActive ? "ring-2 ring-primary border-primary" : ""}
                ${disabled ? "opacity-50" : ""}`}
            >
              {s.char ?? (s.hasFakeCaret ? <span className="animate-pulse">|</span> : "")}
            </div>
          ))}
        </>
      )}
    />
  );
}
